/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pack-table.vue?vue&type=template&id=0e4dd96c&scoped=true&"
import script from "./pack-table.vue?vue&type=script&lang=ts&"
export * from "./pack-table.vue?vue&type=script&lang=ts&"
import style0 from "./pack-table.vue?vue&type=style&index=0&id=0e4dd96c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4dd96c",
  null
  
)

export default component.exports